import "./../css/style.scss";
import $ from 'jquery';

$(document).ready(function () {


    // cookiebot manual block cookies start

    categorizeIframesByDomain();

    $('.video_wrap').click(function () {
        categorizeIframesByDomain();
    });
    $('.ytp-cued-thumbnail-overlay-image').click(function () {
        categorizeIframesByDomain();
    });

    //Slick
    $('.case-studies-slider__posts').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
    });
    $('.success-stories-slider-block').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 989,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });

    $('.photo-album-one').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.photo-album-multi'
    });
    $('.photo-album-multi').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.photo-album-one',
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '0px',
    });
    $('.cubes-with-numbers').slick({
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: false,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            },
        ]
    });

    //Parallax list items
    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    $(window).on('resize scroll', function () {
        if ($('.subpage_wrap').length) {
            // $('.subpage_wrap .list_item').each(function () {
            //     if ($(this).isInViewport()) {
            //         $(this).addClass("animation");
            //     } else {
            //         $(this).removeClass("animation");
            //     }
            // })
        }
        // if ($('.opacity-box-li-checks').length) {
        //     $('.opacity-box-li-checks li').each(function () {
        //         if ($(this).isInViewport()) {
        //             $(this).addClass("animation");
        //         } else {
        //             $(this).removeClass("animation");
        //         }
        //     })
        // }

        if ($('.progress-ring').length) {
            $('.progress-ring').each(function () {
                if ($(this).isInViewport()) {
                    var circle = $(this).find('circle');
                    const data = $(this).attr('data')
                    if (data < 101 && data > -1) {
                        setProgress(circle, data);
                    }
                }
            });
        }


    });

    // Mobile menu
    $('#menu-mobile .menu-item-has-children>a').append("<span class='menu-dropdown'></span>");

    $('#menu-mobile .menu-item-has-children a .menu-dropdown').on('click', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if ($(this).parent().hasClass( "ow-show-submenu" )) {
            $(this).parent().removeClass("ow-show-submenu");
            $(this).parent().siblings('.sub-menu').slideUp('fast').removeClass("active");
        }
        else {
            $(this).parent().addClass("ow-show-submenu");
            $(this).parent().siblings('.sub-menu').slideToggle('fast').addClass("active");
        }
    });


    // Data sucess stories circle
    function setProgress(circle, percent) {
        var radius = circle.attr("r");
        var circumference = radius * 2 * Math.PI;
        const offset = circumference - percent / 100 * circumference;
        circle.css("stroke-dashoffset", offset);
    }

    if ($(window).width() < 1201) {
        $('.success-data .progress-ring circle').attr("r", 70);
    }
    if ($(window).width() < 400) {
        $('.success-data .progress-ring circle').attr("r", 60);
    }

    //Scroll
    var lastScrollTop = 0;
    $(window).scroll(function () {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            //down
            $('#header').addClass("header-scroll-down");
            $('#header').removeClass("header-scroll-up");
        } else if (st == 0) {
            $('#header').removeClass("header-scroll-up");
            $('#header').removeClass("header-scroll-down");
        } else if (st == lastScrollTop) {
            $('#header').addClass("header-scroll-down");
            $('#header').removeClass("header-scroll-up");
        } else {
            //up
            $('#header').addClass("header-scroll-up");
            $('#header').removeClass("header-scroll-down");
        }
        lastScrollTop = st;
    });

    //Numbers
    if ($('.numbers-block').length) {
        var checker = true;
        // $(window).on('resize scroll', function () {
        if ($('.numbers-block').isInViewport() && checker) {
            $('.numbers-block__value').each(function () {
                $(this).prop('Counter', 0).animate({
                    Counter: $(this).attr('value')
                }, {
                    duration: 4000,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(Math.ceil(now));
                    }
                });
            });
            checker = false;
        }

        if (!$('.numbers-block').isInViewport()) {
            checker = true; // ta celotni if nam animacijo požene vsakič na novo, ko smo ponovno v viewportu
        }
        // });
    }

    //Video
    if ($('.video_wrap a').length) {
        $('.video_wrap a').on('click', function (e) {
            e.preventDefault();
        });
        const videoUrl = $('.video_wrap a').attr('href');
        const embed =  $('.video_wrap a').attr('src');
        $('.video_wrap a').magnificPopup({
            items: {
                src: videoUrl
            },
            type: 'iframe',
            iframe: {
                markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: 'v=',
                        src: embed
                    }
                },
                srcAction: 'iframe_src',
            }
        });
    }

    //Animations
    // if ($('h2').isInViewport()) {
    //     $(this).addClass('underline');
    // }
    $(window).on('resize scroll', function () {
        if ($('h2').length) {
            $('h2').each(function () {
                if ($(this).isInViewport()) {
                    $(this).addClass("underline--green");
                }
            })
        }
    });

    $.fn.moveUp = function (element) {
        if ($(element).length) {
            $(element).addClass('move-up');
            $(element).each(function () {
                if ($(this).isInViewport()) {
                    $(this).addClass("fade-in");
                }
            });
            $(window).on('resize scroll', function () {
                if ($(element).length) {
                    $(element).each(function () {
                        if ($(this).isInViewport()) {
                            $(this).addClass("fade-in");
                        }
                        // else {
                        //     $(this).removeClass("fade-in");
                        // }
                    })
                }
            });
        }
    }
    // $('.success-stories .text-image-block').addClass('move-up');
    $(this).moveUp('.success-stories .text-image-block');
    // $('.faq-block').addClass('move-up');
    $(this).moveUp('.faq-block');


    $.fn.listOneByOne = function (block, element) {
        if ($(element).length) {
            $(element).addClass('list-one-by-one');
            $(element).each(function () {
                if ($(this).isInViewport()) {
                    $(this).addClass("fade-in");
                }
            });
            $(window).on('resize scroll', function () {
                if ($(element).length) {
                    $(element).each(function () {
                        var single = $(this);
                        if ($(block).isInViewport()) {
                            single.addClass("fade-in");
                        }
                    })
                }
            });
        }
    }

    // $('.partners-block .partners-block__partners a').addClass('list-one-by-one');
    $(this).listOneByOne('.partners-block', '.partners-block .partners-block__partners .single-partner__outer');
    // $('.columns-icons-block__columns .single-column').addClass('list-one-by-one');
    $(this).listOneByOne('.columns-icons-block__columns', '.columns-icons-block__columns .single-column');
    // $('.events-block__cards .event-card').addClass('list-one-by-one');
    $(this).listOneByOne('.events-block__cards', '.events-block__cards .event-card');
    // $('.columns .single-column').addClass('list-one-by-one');
    $(this).listOneByOne('.columns ', '.columns  .single-column');
    // $(this).listOneByOne('.subpage_wrap ', '.subpage_wrap .list_item');
    // $(this).listOneByOne('.opacity-box-li-checks ', '.opacity-box-li-checks li');


    $.fn.bringUp = function (element) {
        if ($(element).length) {
            $(element).addClass('bring-up');
            $(element).each(function () {
                if ($(this).isInViewport()) {
                    $(this).addClass("fade-in");
                }
            });
            $(window).on('resize scroll', function () {
                if ($(element).length) {
                    $(element).each(function () {
                        if ($(this).isInViewport()) {
                            $(this).addClass("fade-in");
                        }
                    })
                }
            });
        }
    }

    // $('.columns-icons-block.shadowfull').addClass('bring-up');
    $(this).bringUp('.columns-icons-block.shadowfull');
    $(this).bringUp('.text-side-image');
    $(this).bringUp('.subpage_wrap');
    // $('.latest-posts').addClass('bring-up');
    $(this).bringUp('.latest-posts');



});

function categorizeIframesByDomain() {
    let iframes = document.querySelectorAll('iframe');

    iframes.forEach(function (iframe) {
        if (iframe.src.includes('youtube.com')) {
            iframe.classList.add('cookieconsent-optin-marketing');
            iframe.setAttribute('data-cookieconsent', 'marketing');
        }
        if (iframe.src.includes('google.com/maps')) {
            iframe.classList.add('cookieconsent-optin-preferences');
            iframe.setAttribute('data-cookieconsent', 'preferences');
        }
    });
}
